export default __webpack_public_path__ + "static/media/Loader.a1a99674.gif";